import {
  QUERY_RESPONSE_RECEIVED,
  MUTATION_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import {
  RADAR_CREATE_SESSIONS,
  RADAR_POLL,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import {
  getFlightsResponseBody,
  isResponseContainFlightsBody,
  isFlightsResponseError,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/flightsResponse';
import keyBy from 'lodash/keyBy';

import { mapRadarSegments } from './segmentsMapper';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { SegmentState } from '@web-platform/shared-universal-types/src/redux/state/entities/flights/segments';

export type {
  Segment,
  SegmentState,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/segments';

export const INITIAL_STATE: SegmentState = {
  byId: {},
};

const segmentsReducer = (state: SegmentState = INITIAL_STATE, action: Action): SegmentState => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      if (action.payload.type === RADAR_CREATE_SESSIONS || action.payload.type === RADAR_POLL) {
        if (
          isFlightsResponseError(action.payload.response) ||
          !isResponseContainFlightsBody(action.payload.response)
        ) {
          return state;
        }

        const flightsResponseBody = getFlightsResponseBody(action.payload.response);
        const segments = mapRadarSegments(flightsResponseBody.results || []);

        return {
          byId: { ...state.byId, ...keyBy(segments, (segment) => segment.id) },
        };
      }

      return state;
    }

    default:
      return state;
  }
};

export default segmentsReducer;
